<!--
 * @Description: 
 * @Author: WangYuhan
 * @Date: 2022-12-09 17:54:05
 * @LastEditTime: 2023-10-28 14:18:17
 * @LastEditors: WangYuhan
-->
<template>
  <div class="nf-select-list">
    <slot name="tips" />

    <slot name="header"></slot>
    <nfHeader
      v-if="haveHeader"
      :storeModelName="storeModelName"
      :isreset="isreset"
      @heightChange="heightChange"
      @initSearch="initSearch"
      @onSearch="onSearch"
      @handleStatusChange="handleStatusChange"
    >
      <template slot="searchName">
        <slot name="searchName" />
      </template>
      <template slot="button">
        <slot name="button" />
      </template>
      <template slot="isCheck">
        <slot name="isCheck" />
      </template>
    </nfHeader>
    <div class="base-table">
      <template v-if="isSpecialTabs">
        <el-tabs
          v-model="isSpecialTabs.value"
          class="base_tabs"
          type="card"
          @tab-click="handleClick"
        >
          <template v-for="(tabItem, tabIndex) in isSpecialTabs.selectList">
            <el-tab-pane :key="tabIndex" :name="tabItem.value">
              <span slot="label" class="status_tabs">
                {{ tabItem.label }}
              </span>
            </el-tab-pane>
          </template>
        </el-tabs>
      </template>
      <div class="base-table-main">
        <slot name="Statistics" />
        <slot name="table" />
      </div>
    </div>
  </div>
</template>

<script>
import nfHeader from '@/components/nf-select-list/components/nf-header';

export default {
  name: 'NfSelectList',
  components: {
    nfHeader,
  },
  props: {
    storeModelName: {
      type: String,
      default: '',
    },
    haveHeader: {
      default: true,
      type: Boolean,
    },
    isreset: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    isSpecialTabs() {
      return this.$store.state[this.storeModelName].isSpecialTabs || false;
    },
  },
  methods: {
    handleClick(value) {},
    heightChange(val) {
      this.$emit('heightChange', val);
    },
    initSearch() {
      this.$emit('initSearch');
    },
    onSearch() {
      this.$emit('onSearch');
    },
    handleStatusChange(val) {
      this.$emit('handleStatusChange', val);
    },
  },
};
</script>
<style lang="scss">
.nf-select-list {
  .top-operation {
    margin: 0 !important;
  }
}
</style>
